import naja from 'naja';

if (!('IntersectionObserver' in window)) {
	require('intersection-observer-amd');
}
import LazyLoad from 'vanilla-lazyload';

class LazyLoadExtension {
	constructor() {}

	initialize(naja) {
		window.LazyLoad = new LazyLoad({
			elements_selector: '.lazy',
		});

		naja.addEventListener('complete', () => {
			if (window.LazyLoad) {
				window.LazyLoad.update();
			}
		});
	}
}

naja.registerExtension(new LazyLoadExtension());
